/* eslint-disable react/require-default-props */
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import { Typography, useTheme } from '@mui/material';
import { LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

type Props = {
  linkName: string;
  linkRoute: string;
  isActive: boolean;
  icon: LucideIcon;
  onNavigate?: () => void;
  badgeCount?: number;
};

function NavLink({
  linkName,
  linkRoute,
  isActive,
  icon: Icon,
  onNavigate,
  badgeCount = 0,
}: Props) {
  const theme = useTheme();

  return (
    <ListItem
      key={linkName}
      disablePadding
      className={isActive ? 'active' : ''}>
      <ListItemButton to={linkRoute} component={Link} onClick={onNavigate}>
        <ListItemIcon>
          <Icon
            size={20}
            strokeWidth={1.75}
            color={
              isActive ? theme.palette.primary.main : theme.palette.text.primary
            }
          />
        </ListItemIcon>
        <ListItemText sx={{ flexGrow: 0, my: 0 }}>
          <Typography variant="body2">{linkName}</Typography>
        </ListItemText>
        {badgeCount > 0 && (
          <Box className="nav-badge">
            {badgeCount > 99 ? '99+' : badgeCount}
          </Box>
        )}
      </ListItemButton>
    </ListItem>
  );
}

export default NavLink;
